"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileHandle = void 0;

var _BaseComponentEntity = require("./BaseComponentEntity");

var _mobxUtils = require("../_helpers/mobx-utils");

var _mobx = require("mobx");

class FileHandle extends _BaseComponentEntity.BaseComponentEntity {
  constructor(file) {
    super();
    this.file = file;
    this.name = file.name;
    this.size = file.size;
    this.visualProgress = 0;
    this.uploadProgress = 0;
    this.downloadProgress = 0;
    this.uploadCompletedAt = null;
    this.abortController = new AbortController();
    this.error = null;
    this.onProgressCompletedCallback = null;
    this.documentId = 0;
    (0, _mobxUtils.makeSubclassObservable)(this);
  }

  get isUploaded() {
    return this.uploadCompletedAt !== null;
  }

  setUploadProgress(visualProgress, uploadProgress, downloadProgress) {
    (0, _mobx.runInAction)(() => {
      this.visualProgress = visualProgress;
      this.uploadProgress = uploadProgress;
      this.downloadProgress = downloadProgress;

      if (this.visualProgress >= 1 && !this.uploadCompletedAt) {
        this.uploadCompletedAt = new Date();

        if (this.onProgressCompletedCallback) {
          this.onProgressCompletedCallback();
        }
      }
    });
  }

  setError(error) {
    (0, _mobx.runInAction)(() => this.error = error);
  }

  setAbortController(controller) {
    (0, _mobx.runInAction)(() => this.abortController = controller);
  }

  setProgressCompletedCallback(callback) {
    (0, _mobx.runInAction)(() => this.onProgressCompletedCallback = callback);
  }

}

exports.FileHandle = FileHandle;